import { Link } from 'react-router-dom';
import { Movie } from '@/mocks/movies';

interface MovieCardProps {
  movie: Movie;
}

export default function MovieCard({ movie }: MovieCardProps) {
  return (
    <Link
      to={`/article/${movie.slug}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
    >
      <div className="relative aspect-[2/3] overflow-hidden">
        <img
          src={movie.imageUrl}
          alt={`${movie.title} 在线观看 - 80s电影网`}
          title={`${movie.title} 高清在线看免费不卡`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 left-2 flex gap-1.5">
          {movie.isNew && (
            <span className="px-2 py-0.5 bg-primary-500 text-background-50 text-[11px] font-medium rounded-md">
              最新
            </span>
          )}
          {movie.isHot && (
            <span className="px-2 py-0.5 bg-accent-500 text-foreground-950 text-[11px] font-medium rounded-md">
              热门
            </span>
          )}
        </div>
        <div className="absolute top-2 right-2">
          <span className="px-2 py-0.5 bg-foreground-950/70 text-accent-400 text-[11px] font-bold rounded-md">
            {movie.rating}
          </span>
        </div>
        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent p-3 pt-8">
          <p className="text-background-50 text-xs leading-relaxed line-clamp-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            {movie.description}
          </p>
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-medium text-foreground-950 mb-1 line-clamp-1 group-hover:text-primary-600 transition-colors">
          {movie.title}
        </h3>
        <div className="flex items-center gap-2 text-xs text-foreground-500">
          <span>{movie.subcategory}</span>
          <span className="text-foreground-300">|</span>
          <span>{movie.year}</span>
        </div>
      </div>
    </Link>
  );
}